"use strict";'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var reactFontawesome = require('@fortawesome/react-fontawesome');
var r = require('styled-components');
var jsxRuntime = require('react/jsx-runtime');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var r__default = /*#__PURE__*/_interopDefaultLegacy(r);

var l=r.css`
  font-size: var(--icon-size-small);
`,a=r.css`
  font-size: var(--icon-size-regular);
`,z=r.css`
  font-size: var(--icon-size-large);
`,m=r.css`
  font-size: var(--icon-size-x-large);
`,g=r__default["default"](reactFontawesome.FontAwesomeIcon)`
  ${o=>o.$size==="small"&&l}
  ${o=>o.$size==="regular"&&a}
  ${o=>o.$size==="large"&&z}
  ${o=>o.$size==="x-large"&&m}

  ${({$colorToken:o})=>o&&`color: var(--${o});`}

  /* Anti-aliasing icons cross-browsers */
  -webkit-font-smoothing: antialiased;
  text-rendering: optimizeLegibility;
`,s=({colorToken:o="",icon:i,size:n="regular",...t})=>i?jsxRuntime.jsx(g,{$colorToken:o,icon:i,$size:n,...t}):null;s.displayName="Icon";var u=r__default["default"](s)``;

exports.a = s;
exports.b = u;
